import clone from 'clone-deep'
// @ts-ignore
import * as isValidHostname from 'is-valid-hostname'
// @ts-ignore
import * as isValidDomain from 'is-valid-domain'
import { DomainDto } from '@halo/dtos/domain.dto'
import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'
import { Domain } from '@pushly/models/lib/structs/domain'

export function prepareWhitelistDomains(domains: string[], allowSubdomainWildcards?: boolean): string[] {
    domains = domains ?? []

    let testDomains = clone(domains)
    if (allowSubdomainWildcards) {
        testDomains = testDomains.map((domainStr) => domainStr.replace(/^\*\./, ''))
    }

    if (Array.isArray(testDomains) && testDomains.length > 0) {
        const invalidDomainMatch = testDomains.some(
            (domainStr: string) => !(isValidHostname(domainStr) || isValidDomain(domainStr)),
        )

        if (invalidDomainMatch) {
            throw {
                whitelistDomains: {
                    errors: [
                        {
                            message:
                                'Whitelist domains must be valid domain names or IP addresses containing no special characters.',
                        },
                    ],
                },
            }
        }
    }

    return domains
}

export type DomainChannelConfig = Pick<Domain, 'flags' | 'nativeApnsConfiguration' | 'nativeFcmConfiguration'>

export function isDeliveryChannelEnabled(
    domain: DomainChannelConfig,
    channel: DeliveryChannel,
    andIsActive?: boolean,
): boolean
export function isDeliveryChannelEnabled(
    domain: DomainChannelConfig,
    channel: DeliveryChannel,
    andIsActive: boolean = false,
): boolean {
    const isEnabled = domain?.flags?.includes(DeliveryChannel.getAssociatedFlag(channel)!) ?? false

    if (!andIsActive) {
        return isEnabled
    }

    const domainChannelPropMap = {
        [DeliveryChannel.WEB]: {
            isActive: domain.flags?.includes(DeliveryChannel.getAssociatedFlag(DeliveryChannel.WEB)!) ?? false,
        },
        [DeliveryChannel.NATIVE_IOS]: domain.nativeApnsConfiguration,
        [DeliveryChannel.NATIVE_ANDROID]: domain.nativeFcmConfiguration,
    }

    return domainChannelPropMap[channel]?.isActive ?? false
}

export function getEnabledDeliveryChannels(domain: DomainChannelConfig, activeOnly?: boolean): DeliveryChannel[]
export function getEnabledDeliveryChannels(
    domain: DomainChannelConfig,
    activeOnly: boolean = false,
): DeliveryChannel[] {
    return DeliveryChannel.getAllChannels()
        .map<[DeliveryChannel, boolean]>((ch) => [ch, isDeliveryChannelEnabled(domain, ch, activeOnly)])
        .filter(([, enabled]) => enabled)
        .map(([ch]) => ch)
}
